import {createStore, StoreApi} from 'zustand/vanilla';
import {Runner, RunnerInterface} from '../models/runner';
import {RUN_FULL, RUN_HALF} from '../models/waypoint';

const cachedFavorites = window.localStorage.getItem('favorite-runner-interfaces');
const cachedFavoriteRunnerInterfaces = cachedFavorites && cachedFavorites !== 'null' ? (
    JSON.parse(cachedFavorites)
) : [];

const now = new Date();
const isHalfMarathonTime = (now.getHours() === 10 && now.getMinutes() <= 30) || now.getHours() < 10;
const defaultRun = isHalfMarathonTime ? RUN_HALF : RUN_FULL;

interface RunnersState {
    favoriteRunnerInterfaces: RunnerInterface[];
    favoriteRunners: Runner[];
    run: string;
    currentRunnerDetail: string;
    setFavoriteRunners: (newRunners: Runner[]) => void;
    clearFavoriteRunners: () => void;
    setCurrentRun: (newRun: string) => void;
    setCurrentRunnerDetail: (startNumber: string | null) => void;
}

export type RunnersStore = RunnersState & StoreApi<RunnersState>;

const store = createStore<RunnersState>((set) => ({
    favoriteRunnerInterfaces: cachedFavoriteRunnerInterfaces,
    favoriteRunners: [],
    run: defaultRun,
    currentRunnerDetail: null,
    setFavoriteRunners: (newRunners) => set((state) => {
        const newRunnerInterfaces = newRunners.map((runner) => {
            return {
                run: runner.run,
                year: runner.year,
                startNumber: runner.startNumber,
            };
        });
        window.localStorage.setItem('favorite-runner-interfaces', JSON.stringify(newRunnerInterfaces));

        return {
            ...state,
            favoriteRunnerInterfaces: newRunnerInterfaces,
            favoriteRunners: newRunners,
        };
    }),
    clearFavoriteRunners: () => set((state) => {
        window.localStorage.removeItem('favorite-runner-interfaces');

        return {
            ...state,
            favoriteRunners: [],
        };
    }),
    setCurrentRun: (newRun) => set((state) => ({
        ...state,
        run: newRun,
    })),
    setCurrentRunnerDetail: (value: string | null) => set((state) => ({
        ...state,
        currentRunnerDetail: value,
    })),
}));

export default (): RunnersStore => ({
    ...store.getState(),
    ...store,
});
